import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Loading,
	Button
} from "~/components";
import {
	InputField,
	TextAreaField,
	GroupRadioField
} from "~/components/Forms";
function UserFormCoinMinus({item, onHandleSubmit}) {

	const { control, handleSubmit, formState: { isSubmitting, errors }} = useForm({
		defaultValues: {
			coin: 0,
			type: 'coin',
			message: ''
		},
		resolver: yupResolver(Yup.object().shape({
			coin: Yup.number().required('Bạn chưa điền số xu muốn trừ đi'),
			type: Yup.string().required('Bạn chưa chọn loại xu muốn trừ'),
			message: Yup.string().required('Bạn chưa điền lý do muốn trừ xu'),
		}))
	});

	const handleCoinMinus = async (data) => {
		await onHandleSubmit(data, item)
	}

	return (
		<form className="form" onSubmit={handleSubmit(handleCoinMinus)}>
			{isSubmitting && <Loading/>}
			<Controller control={control} name="coin" render={({ field }) => (
				<InputField label="Số xu muốn trừ đi" type={'number'} errors={errors} {...field}/>
			)}/>
			<Controller control={control} name="type" render={({field}) => (
				<GroupRadioField options={[
					{value: 'coin', label: 'Xu vĩnh viển'},
					{value: 'sale', label: 'Xu khuyến mãi'},
				]} errors={errors} {...field}/>
			)}/>
			<Controller control={control} name="message" render={({ field }) => (
				<TextAreaField label="Lý do muốn trừ xu" errors={errors} {...field}/>
			)}/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Trừ Xu</Button>
			</div>
		</form>
	)
}

export default UserFormCoinMinus;